'use strict';

var util = require('../util'),
	ajax = require('../ajax'),
	validator = require('../validator'),
	progress = require('../progress'),
	jcalendar = require('../jcalendar'),
	formPrepare = require('./checkout/formPrepare'),
	dialog = require('../dialog'),
	linchpin = require('int_googletagmanager/linchpin/reminders');

/**
 * @function
 * @description Initializes the events on the reminders form (apply, cancel)
 */
function initializeRemindersForm () {
	var $form = $('#edit-reminder-form');

	formPrepare.init({
		continueSelector:'#edit-reminder-form .apply-button',
		formSelector:'#edit-reminder-form'
	});

	$form.on('click', '.apply-button', function (e) {
		e.preventDefault();
		if (!$form.valid()) {
			return false;
		}

		if ($('[name$="reminderoccasion"]').val() !== 'Other') {
			$('[name$="reminderoccasionother"]').val('');
		}

		$('<input/>').attr({
			name: $(this).attr('name'),
			type: 'hidden'
		}).appendTo($form);

		var options = {
			url: $form.attr('action'),
			data: $form.serialize() + '&format=ajax',
			type: 'POST'
		};
		progress.show($('#reminders'));
		$.ajax(options).always(function (data) {
			if (data && data.success) {
				ajax.load({
					url:util.ajaxUrl(Urls.reminderList),
					target:$('#reminders'),
					callback: function () {
						progress.hide();
						dialog.close();
						reminderUpdateAjaxCallback();
					}
				});
				var action = $('#dialog-container h1').text();
				if (action.indexOf('Add') > -1) {
					// GTM Linchpin analytics
					if (SitePreferences.GTM_ENABLED) {
						linchpin.addReminderEvent(e, data.reminderid);
					}
				} else if (action.indexOf('Edit') > -1) {
					// GTM Linchpin analytics
					if (SitePreferences.GTM_ENABLED) {
						linchpin.editReminderEvent(e);
					}
				}
			} else {
				if (data.invalidReminder) {
					var reminderErrorExists = $('.invalid-reminder').css('display') === 'block';
					if (!reminderErrorExists) {
						$('.invalid-reminder').toggleClass('hide');
					}
				}
				progress.hide();
				//error after address form submission
			}
		});
	});
	$('.cancel-button').on('click', function (e) {
		e.preventDefault();
		dialog.close();
	});

	$('input.input-text').on('change', function () {
		this.value = util.removeInvalidChars(this.value);
	});

	if ($form.find('[name$="reminderoccasion"]').val() !== 'Other') {
		$form.find('[name$="reminderoccasionother"]').val('');
	}

	updateOccasionTypeState();
	$form.find('[name$="reminderoccasion"]').on('change', function () {
		updateOccasionTypeState();
	});

	setTimeout(function () {
		validator.initForm($form);
		$form.find('.input-checkbox, select').uniform();
		jcalendar.init($form.find('[name$="_eventdate"]'), {
			'container':$form.find('.event-date'),
			'calendarClass': 'reminder-datepicker',
			'maxDate': ''
		});
		util.limitCharatersCounter();
		util.limitCharacters($form);
	}, 40);
}

function updateOccasionTypeState() {
	var reminderOccasion = $('[name$="reminderoccasion"]');
	var otherOccasion = $('[name$="reminderoccasionother"]');
	if (reminderOccasion.val() === 'Other') {
		$('.other-occasion-container').removeClass('hide');
		otherOccasion.addClass('required');
		formPrepare.init({
			continueSelector:'#edit-reminder-form .apply-button',
			formSelector:'#edit-reminder-form'
		});
	} else {
		$('.other-occasion-container').addClass('hide');
		otherOccasion.removeClass('required').rules('remove');
		if (otherOccasion.hasClass('error')) {
			otherOccasion.removeClass('error');
			$('#edit-reminder-form').validate().element(otherOccasion);
		}
		formPrepare.init({
			continueSelector:'#edit-reminder-form .apply-button',
			formSelector:'#edit-reminder-form'
		});
	}
}

function reminderUpdateAjaxCallback () {
	$('.toggle-title').on('click touchstart', function (e) {
		$(this).toggleClass('on').next('.toggleContent').toggleClass('show');
		e.preventDefault();
	});
}
/**
 * @function
 * @description Binds the events on the reminders form (edit, create, delete)
 */
function initRemindersEvents() {
	var reminders = $('#reminders');
	if (reminders.length === 0) { return; }

	reminders.on('click', '.reminder-edit, .reminder-create', function (e) {
		e.preventDefault();
		dialog.open({
			url: this.href,
			options: {
				buttons:[],
				dialogClass:'addedit-reminder-dialog no-title',
				open: initializeRemindersForm
			}
		});
	})
	.on('click', '.delete', function (e) {
		e.preventDefault();
		var url = this.href;
		dialog.open({
			url: Urls.removeReminderPopup,
			options: {
				buttons: [
					{
						text: Resources.NO,
						'class':'button-gray',
						click: function () {
							dialog.close();
						}
					},
					{
						text: Resources.YES,
						click: function () {
							progress.show('#reminders');
							// GTM Linchpin analytics
							if (SitePreferences.GTM_ENABLED) {
								linchpin.removeReminderEvent(e);
							}
							ajax.load({
								url:url,
								target:$('#reminders'),
								callback: function () {
									progress.hide();
									dialog.close();
									reminderUpdateAjaxCallback();
								}
							});
						}
					}
				],
				dialogClass: 'yes-and-no-dialog',
				title: Resources.REMOVE_REMINDER_TITLE
			}
		});
	});
}

var reminders = {
	init: function () {
		initRemindersEvents();
	}
};

module.exports = reminders;
